import { useSelector } from 'react-redux';
import Snackbar from './TransitionsQRSnackbar';

import { useTranslateErrorMessage } from '../../utils';

export default function NotificationQR() {
  const { open, notification } = useSelector((store) => store.notificationQR);
  const { translateMessage } = useTranslateErrorMessage();

  if (open) {
    return (
      <Snackbar
        open={open}
        message={translateMessage(notification.message)}
        severity={notification.type}
        color={notification.color}
      />
    );
  }

  return [];
}
